import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs, Typography, Link as MuiLink, makeStyles, Theme } from "@material-ui/core";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

const useStyles = makeStyles((theme: Theme) => ({
  breadcrumbs: {
    fontSize: 12,
    color: "#000",
  },
}));
interface Props {
  heading?: string;
  module?: string;
  linkTo?: string;
}

export default function TabHeader({
  heading = "Enter a heading",
  module = "Enter Module Name...",
  linkTo,
}: Props): ReactElement {
  const classes = useStyles();
  return (
    <Breadcrumbs
      className={classes.breadcrumbs}
      aria-label="breadcrumb"
      separator={<NavigateNextIcon fontSize="inherit" />}
    >
      <MuiLink
        color="inherit"
        component={Link}
        to={`/${linkTo || module}`}
        className={classes.breadcrumbs}
      >
        {module}
      </MuiLink>
      <Typography className={classes.breadcrumbs}>{heading}</Typography>
    </Breadcrumbs>
  );
}
